import { safeParse, safeParseAsync } from "valibot";
const valibotValidator = () => {
  return {
    validate({ value }, fn) {
      if (fn.async)
        return;
      const result = safeParse(fn, value);
      if (result.success)
        return;
      return result.issues.map((i) => i.message).join(", ");
    },
    async validateAsync({ value }, fn) {
      const result = await safeParseAsync(fn, value);
      if (result.success)
        return;
      return result.issues.map((i) => i.message).join(", ");
    }
  };
};
export {
  valibotValidator
};
//# sourceMappingURL=validator.js.map
